import React, { useState } from 'react';
import * as XLSX from 'xlsx';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { GetResultSummaryList } from '../../../../../store/HR/Raqeeb/raqeebSlice';
import useGetRotationPlan from '../../../../../hooks/HR/use-get-RotationPlan';
import useGetPersons from '../../../../../hooks/HR/use-get-persons';
import Select from 'react-select';
import TableSummaryList from './TableSummaryList';

const SummaryList = () => {
  const [results, setResults] = useState([]); // حالة محلية لتخزين النتائج
  const [loading, setLoading] = useState(false); // حالة لتحميل البيانات
  // const [error, setError] = useState(null); // حالة لتخزين الأخطاء

  const [dateRange, setDateRange] = useState({
    fromDate: '',
    toDate: '',
    personId: null,
    rotationPlanId: null,
  });

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const {  RotationPlanOptions } = useGetRotationPlan();
  const { dataEmployees, loading: loadingPer } = useGetPersons();

  const handleGetResult = async () => {
    setLoading(true);
    // setError(null);
    try {
      const result = await dispatch(
        GetResultSummaryList({
          DateFrom: dateRange.fromDate,
          DateTo: dateRange.toDate,
          RotationPlanId: dateRange.rotationPlanId,
          PersonId: dateRange.personId,
        })
      ).unwrap();
      debugger;
      if (result?.succeeded) {
        setResults(result.data || []); // تخزين النتيجة
      } else {
        // setError(result.message || 'Something went wrong');
      }
    } catch (err) {
      // setError(err.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  //#region exportToExcel

  const exportToExcel = () => {
    const workbook = XLSX.utils.book_new();

    // const headline = [
    //   ['Names of employees for Branch No. 7'], // Your headline goes here
    //   [], // Empty array for spacing
    // ];

    // Add headline to worksheet
    // XLSX.utils.sheet_add_aoa(worksheet, headline, { origin: -1 });

    const csvContent = results?.map((entry) => ({
      'Employee Number': entry.employeeNumber,
      EmployeeName: entry.employeeName,
      // "EmployeeName 2": entry.employeeName2,
      'Location Name': entry.locationName,
      'Organization Name': entry.organizationName,
      'Rotation Plan Name': entry.rotationPlanName,
      Duration: entry.durationS,
      'Actual Duration': entry.durationActS,
      Delay: entry.delayS,
      'Extra Hours': entry.overTimeS,
      Absence: entry.absence,
    }));

    const worksheet = XLSX.utils.json_to_sheet(csvContent);
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      `${dateRange.fromDate} => ${dateRange.toDate}`
    );

    XLSX.writeFile(workbook, 'Azzad_Summary_analysis_data.xlsx');
  };

  //#endregion

  return (
    <>
      <div className="row  ">
        <div className="col-xl-4">
          <div className="row">
            <div className="col-xl-12">
              <div className="input-group mb-3 ">
                <span className="input-group-text">{t('From')}</span>

                <input
                  type="date"
                  className="form-control text-center"
                  value={dateRange.fromDate}
                  onChange={(e) => setDateRange({ ...dateRange, fromDate: e.target.value })}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="input-group mb-3">
                <span className="input-group-text">{t('To')}</span>
                <input
                  type="date"
                  className="form-control text-center"
                  value={dateRange.toDate}
                  onChange={(e) => setDateRange({ ...dateRange, toDate: e.target.value })}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-5">
          <div className="row">
           

            <div className="col-xl-12">
              <div className="input-group flex-nowrap mb-3">
                <span className="input-group-text  fw-bold">{t('RotationPlan')}</span>
                <Select
                  classNamePrefix="react-select"
                  className="w-100"
                  isLoading={loadingPer}
                  isSearchable={true}
                  isClearable
                  options={RotationPlanOptions}
                  onChange={(option) => {
                    setDateRange({ ...dateRange, rotationPlanId: option ? option.value : null });
                  }}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
              </div>
            </div>
            <div className="col-xl-12">
              <div className="input-group flex-nowrap">
                <span className="input-group-text  fw-bold">{t('Employee')}</span>
                <Select
                  classNamePrefix="react-select"
                  className="w-100"
                  isLoading={loadingPer}
                  isSearchable={true}
                  isClearable
                  name="personId"
                  options={dataEmployees}
                  onChange={(option) => {
                    setDateRange({ ...dateRange, personId: option ? option.value : null });
                  }}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  filterOption={(candidate, inputValue) => {
                    // البحث في الاسم أو رقم الموظف
                    const searchValue = inputValue.toLowerCase();
                    const labelMatches = candidate?.label?.toLowerCase()?.includes(searchValue);
                    const numberMatches = candidate?.data?.employeeNumber
                      ?.toLowerCase()
                      .includes(searchValue);
                    return labelMatches || numberMatches;
                  }}
                  formatOptionLabel={(option) => (
                    <div className="d-flex justify-content-between   ">
                      <div className="">{option.label}</div>
                      <div className="text-theme fw-bold">{option.employeeNumber}</div>
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3">
          <div className="row ">
            <div className="col-xl-12 mb-3">
              <button
                type="button"
                className="btn btn-outline-theme w-100"
                onClick={handleGetResult}>
                {loading ? (
                  <div className="spinner-border spinner-border-sm me-2"></div>
                ) : (
                  <i className="fas fa-calendar-alt fa-lg fa-fw me-2 "></i>
                )}
                                {t('Show')}

              </button>
            </div>

            <div className="col-xl-12 text-end">
              <button
                disabled={true}
                // disabled={results?.length === 0}
                onClick={exportToExcel}
                // className="btn btn-outline-theme text-nowrap rounded-2"
                className={`btn w-100 rounded-2 ${
                  results?.length === 0 ? ' btn-outline-theme ' : ' btn-theme'
                } `}
                tabIndex={0}
                aria-controls="datatable"
                type="button">
                <span>
                  <i className="fa fa-file-excel fa-fw me-1" /> {t('ExportData')}
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

    

      {loading ? (
        <div className="text-center p-2 ">
          <div className="spinner-grow text-success"></div>
          <div className="spinner-grow text-danger"></div>
          <div className="spinner-grow text-warning"></div>
        </div>
      ) : (
        <div className="row bg-inverse bg-opacity-10 p-2 rounded-2 mb-3">
          <TableSummaryList SummaryList={results} />
        </div>
      )}
    </>
  );
};

export default SummaryList;
